import common from "../common";
import Manager from "./Manager";

export default class FloorTileManager extends Manager {

    constructor(tileContainer, textureIds) {
        super(tileContainer);
        this._textureIds = textureIds;
        this.worldLength = 12000;

        this._stopped = false;
    }

    populate(length, y = 0) {
        let x = -400;
        for (let i = 0; i < length; i++) {
            const tile = new PIXI.Sprite(P3.assets.texture(P3.utils.selectRandom(this._textureIds)));
            tile.position.set(x, y - common.STAGE_HEIGHT);
            this._container.addChild(tile);

            x += tile.width;
        }
    }

    update() {
        if (this._stopped)
            return;

        for (let i = 0; i < this._container.children.length; i++) {
            const tile = this._container.children[i];
            const global = tile.getGlobalPosition();
            if (global.x <= -tile.width) {
                // pick a random texture
                tile.texture = P3.assets.texture(P3.utils.selectRandom(this._textureIds));
                // place at end of children
                const lastTile = this._container.children[this._container.children.length - 1];
                tile.x = lastTile.x + tile.width;
                this._container.removeChild(tile);
                this._container.addChild(tile);

                if (tile.x > this.worldLength) {
                    this._stopped = true;
                    break;
                }
            }
        }
    }

}